import { Commit, ActionTree, Dispatch } from 'vuex';
import { AxiosResponse } from 'axios';
import fragmentAll from '@/store/modules/browser/browserCommonState/browser.metrics.types';
import axiosInstance from '@/services/api/http.service';
import getEnv from '@/utils/env';
import {
  NAVTABS,
  BROWSER_ENTIY
} from '@/utils/templates/Browser/browser.constants';
import { CLIENT_IP, FALLBACK_IP,BW_APP_INDEX } from '@/utils/constants';
import { State } from '@/store/modules/browser/browserCommonState/browserCommon.store';
import graphQl from '@/services/graphQl';
const OAP_HOST = getEnv('VUE_APP_OAP_HOST') || 'http://localhost:12800';

const actions: ActionTree<State, any> = {
  getBrowserGraphData(
    context: {
      commit: Commit;
      dispatch: Dispatch;
      getters: any;
      rootState: any;
    },
    params: {
      index: number;
      duration: any;
      type: string;
      dashboardType: { type: string; isDatabase: boolean };
      layoutIndex: number;
      children: { present: boolean; childIndex: number };
      compareDuration: any;
    }
  ) {
    //TO Have to make some changes here
    const {
      currentBrowserPage,
      currentBrowserVersion,
      currentBrowserService
    } = context.rootState.browserState.browserCommonState;
    /**
     *
     * variable  for determining the service type .
     * @description this is database query , if normal is true then the entity is database else it is for application
     * @param {boolean}
     */
    const normal = params.dashboardType.isDatabase ? false : true;

    let config = {} as any;
    const names = ['readSampledRecords', 'sortMetrics'];
    /**
     *
     * Switch for cheking the current tab of browser monitoring and loading the graph templates accordingly.
     * @description checks for diffrent tabs and layouts
     * @param {string}
     */
    // switch (context.rootState.apmState.dashboard.currentTab) {
    switch (context.rootState.browserState.browserCommonState.currentTab) {
      case NAVTABS.BROWSER_APPLICATION_TAB:
        if (params.children.present) {
          config =
            context.rootState.globalState.app.chartsTemplate.application[
              params.layoutIndex
            ][params.index].childQueries[params.children.childIndex];
          break;
        } else {
          config =
            context.rootState.globalState.app.chartsTemplate.application[
              params.layoutIndex
            ][params.index];
          break;
        }
      case NAVTABS.BROWSER_PAGE_TAB:
        if (params.children.present) {
          config =
            context.rootState.globalState.app.chartsTemplate.pages[
              params.layoutIndex
            ][params.index].childQueries[params.children.childIndex];
          break;
        } else {
          config =
            context.rootState.globalState.app.chartsTemplate.pages[
              params.layoutIndex
            ][params.index];
          break;
        }
      case NAVTABS.BROWSER_ERRORS_TAB:
        if (params.children.present) {
          config =
            context.rootState.globalState.app.chartsTemplate.instance[
              params.layoutIndex
            ][params.index].childQueries[params.children.childIndex];
          break;
        } else {
          config =
            context.rootState.globalState.app.chartsTemplate.instance[
              params.layoutIndex
            ][params.index];
          break;
        }
      default:
        config =
          context.rootState.globalState.app.chartsTemplate.service[
            params.index
          ];
        break;
    }

    if (!config) {
      return;
    }
    if (!config.metricName) {
      return;
    }
    /**
     * @description remove the space at the beginning and end of the string.
     */
    const {
      syntheticUserEnabled
    } = context.rootState.browserState.browserCommonState;
    const metricNames = config.metricName
      .split(',')
      .map((item: string) => item.replace(/^\s*|\s*$/g, ''));
    const labelsIndex = (config.labelsIndex || '')
      .split(',')
      .map((item: string) => item.replace(/^\s*|\s*$/g, ''));
    /**
     * @description add the current browser service to the ID
     * @param {string}
     */
    const currentBrowserServiceId = config.independentSelector
      ? config.currentBrowserService
      : currentBrowserService.key;
    /**
     * @description add the current version tag  to the ID.
     * @param {string}
     */
    const currentBrowserVersionId = config.independentSelector
      ? config.currentBrowserVersion
      : currentBrowserVersion.key;
    /**
     * @description add the current browser page to the ID.
     * @param {string}
     */
    const currentBrowserPageId = config.independentSelector
      ? config.currentBrowserPage
      : currentBrowserPage.key;
    const labels =
      config.metricType === 'LABELED_VALUE' ? labelsIndex : undefined;
    /**
     * @constant
     * @example
     *  * # Contents of `variablesList`
     * ```Array
     * [
     *   {
     *  "duration": {
     *    "start": "2021-06-09",
     *     "end": "2021-07-09",
     *      "step": "DAY"
     *  },
     *   "condition": {
     *    "name": "service_apdex",
     *     "entity": {
     *          "scope": "Service",
     *        "serviceName": "eyduYW1lJzonZ28tYXBpLXVzZXInLCd0ZWFtSUQnOidiNzA2ODFhOC00ZWI3LTQ2OGYtOGJlNi04NWRlZDQ1NzEyM2EnLCd0eXBlJzonQSd9.1",
     *       "normal": true
     *     }
     *  }
     * }
     * ]
     * ```
     * @description creates the variable for grqphQL API
     *
     */
    const variablesList: Array<any> = metricNames.map((name: string) => {
      let variables = {} as any;
      /**
       * @description This is for getting global data
       */
      if (config.entityType === 'All') {
        variables = names.includes(config.queryMetricType)
          ? {
              duration: params.duration,
              condition: {
                name,
                parentService: null,
                normal: true,
                scope: config.entityType,
                topN: 10,
                order: config.sortOrder || 'DES'
              }
            }
          : {
              duration: params.duration,
              condition: {
                name,
                entity: {
                  scope: config.entityType,
                  normal: true
                }
              },
              labels
            };
      } else {
        /**
         * @description This macthes the query types and constructs the graphQL API
         * @example
         *  * # Contents of `variablesList`
         * ```
         *  "name": "service_apdex",
         *  * ```
         */
        if (names.includes(config.queryMetricType)) {
          const parentService = normal ? currentBrowserServiceId : '';
          if (config.parentService && !parentService) {
            return;
          }
          variables = {
            duration: params.duration,
            condition: {
              name,
              parentService: config.parentService
                ? currentBrowserService.key
                : null,
              normal,
              scope: normal
                ? config.entityType
                : config.parentService
                ? 'Service'
                : config.entityType,
              topN: 10,
              order: config.sortOrder || 'DES'
            }
          };
          if (syntheticUserEnabled&&name!=BW_APP_INDEX)
          variables.condition[CLIENT_IP] =
            getEnv('VUE_APP_SYNTH_USR_IP') || FALLBACK_IP;
        } else {
          const serviceName = normal ? currentBrowserServiceId : null;
          if (!serviceName) {
            return null;
          }
          if (
            config.entityType === BROWSER_ENTIY.BROWSER_VERSION_ENTITY &&
            !currentBrowserVersionId
          ) {
            return null;
          }
          if (
            config.entityType === BROWSER_ENTIY.BROWSER_PAGE_ENTITY &&
            !currentBrowserPageId
          ) {
            return null;
          }
          /**
           * @description variable constructor
           */
          variables = {
            condition: {
              name,
              entity: {
                scope: normal
                  ? config.entityType
                  : BROWSER_ENTIY.BROWSER_APPLICATION_ENTITY,
                serviceName,
                serviceInstanceName:
                  config.entityType === BROWSER_ENTIY.BROWSER_VERSION_ENTITY
                    ? currentBrowserVersionId
                    : undefined,
                endpointName:
                  config.entityType === BROWSER_ENTIY.BROWSER_PAGE_ENTITY
                    ? currentBrowserPageId
                    : undefined,
                normal
              }
            },
            labels
          };
          if (context.rootState.globalState.settings.isCompareOptionsSelected && config.queryMetricType === "readCustomMetricsValues") {
            variables.durationCurrent = params.duration;
            variables.durationCompared = params.compareDuration;
          } else {
            variables.duration = params.duration;
          }
          if (syntheticUserEnabled&&name!=BW_APP_INDEX)
          variables.condition.entity[CLIENT_IP] =
            getEnv('VUE_APP_SYNTH_USR_IP') || FALLBACK_IP;


        }
      }
     
      return variables;
    });
    const globalArr: any = fragmentAll;
    if (!config.queryMetricType || !variablesList.length) {
      return;
    }
    const metricTypeKey = (context.rootState.globalState.settings.isCompareOptionsSelected  && config.queryMetricType === "readCustomMetricsValues") ? `${config.queryMetricType}Compare` : config.queryMetricType;
    const fragments = globalArr[metricTypeKey].fragment;
    const queryVariables = globalArr[metricTypeKey].variable;
    const query = `query queryData(${queryVariables}) {${fragments}}`;
    return Promise.all(
      variablesList.map((variable: any) => {
        if (variable) {
          return new axiosInstance({ auth: true })
            .post(
              OAP_HOST + '/graphql',
            { query, variables: variable },
              {
                // cancelToken: cancelToken()
              }
            )
            .then((res: AxiosResponse<any>) => {
              const resData = res.data.data;
              if (variable.condition.name === 'browser_app_pv') {
                if (resData.readCustomMetricsValues.total > 0) {
                  context.commit('setBrowserApdexEnabled', true);
                } else {
                  context.commit('setBrowserApdexEnabled', false);
                }
              }
              return {
                ...resData,
                config,
                metricName: variable.condition.name
              };
            });
        } else {
          return { config };
        }
      })
    ).then((data: any) => {
      return data;
    });
  },
  async getBrowserData(
    context: { commit: Commit; rootState: any },
    params: { serviceReq: any; duration: any }
  ): Promise<any> {
    if (!params.serviceReq) {
      params.serviceReq = {
        capability: 'B'
      };
    }
    return graphQl
      .query('queryAllServices')
      .params(params)
      .then(async (res: AxiosResponse) => {
        context.commit('setBrowserServices', res.data.data.services);
      }).catch(error=> error);
  },
  async selectBrowserService(
    context: { commit: Commit; dispatch: Dispatch },
    params: any
  ): Promise<any> {
    if (!params.service && !params.serviceId) {
      return;
    }
    context.commit('setCurrentBrowserService', params.service || params.serviceId);
  },
  async selectBrowserPages(
    context: { commit: Commit; dispatch: Dispatch },
    params: any
  ): Promise<any> {
    if (!params) {
      return;
    }
    context.commit('setCurrentBrowserPage', {
      key: params.page.id,
      label: params.page.name
    });
  },
  setSyntheticUser(
    context: { commit: Commit; dispatch: Dispatch },
    params: any
  ) {
    context.commit('setSyntheticUser', params);
  }
};

export default actions;
